import httpService from '@/api/httpService'
const storeApi = {
    //목록 - 페이징(get list of goods)
    //https://dev.clp.kr/spc/api/static/docs/spc_goods_list.html#resources-spc-goods-list_http_request
    goodsList(params) {
        return httpService.get(`/spc/inventory`,params)
        //return httpService.get(`/spc/goods`, params)
    },

    // 상세(Details)
    // https://dev.clp.kr/spc/api/static/docs/spc_inventory_item.html#resources-spc-inventory-item-fetch-detail_http_request
    storeView(params) {
        return httpService.get(`/spc/inventory/${params.goodsId}`)
    },
    storeViewHistoryChange(params) {
        return httpService.get(`/spc/inventory/${params.goodsId}/history/change`)
    },
    storeUpdate(id,params) {
        return httpService.put(`/spc/inventory/${id}`,params)
    },
     // upload image
     upload(file) {
        let formData = new FormData();
        formData.append("file", file);
        return httpService.post("/common/attachment", formData)
    },
    
    //제품 검색 (카테고리)
    //https://dev.clp.kr/spc/api/static/docs/spc_goods_category.html#resources-spc-goods-category_request_parameters
    storeProductCategory() {
        return httpService.get(`/spc/goods/category`,)
    },

    //제품 검색
    //https://dev.clp.kr/spc/api/static/docs/spc_goods_list.html#resources-spc-goods-paging-fetch_http_request
    storeProductSearch(params) {
        return httpService.get(`/spc/goods`,params)
    },

    //등록(Registration)
    //https://dev.clp.kr/spc/api/static/docs/spc_inventory_item.html#resources-spc-inventory-item-register_http_request
    storeProductAdd(params) {
        return httpService.post(`/spc/inventory`,params)
    },

    deleteProduct(id){
        return httpService.delete(`/spc/inventory/${id}`)
    },

    // 요청(Request)
    // https://dev.clp.kr/spc/api/static/docs/spc_goods_list.html#resources-spc-goods-detail_http_request
    storeGoodsId(params) {
        return httpService.get(`/spc/goods/${params.goodsId}`)
    },
   
}
// export const 
export default storeApi